/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuditAction } from './AuditAction';
import {
    AuditActionFromJSON,
    AuditActionFromJSONTyped,
    AuditActionToJSON,
} from './AuditAction';
import type { AuditLogEntry } from './AuditLogEntry';
import {
    AuditLogEntryFromJSON,
    AuditLogEntryFromJSONTyped,
    AuditLogEntryToJSON,
} from './AuditLogEntry';

/**
 * Represents the results of a query into the audit dataset in BigQuery without filtering or transformation.
 * @export
 * @interface UserAuditLogQueryResponse
 */
export interface UserAuditLogQueryResponse {
    /**
     * Re-constructed objects for each composite action in the query results.
     * @type {Array<AuditAction>}
     * @memberof UserAuditLogQueryResponse
     */
    actions: Array<AuditAction>;
    /**
     * 
     * @type {Array<AuditLogEntry>}
     * @memberof UserAuditLogQueryResponse
     */
    logEntries: Array<AuditLogEntry>;
    /**
     * Copy of the query used in BigQuery to assist in further exploration or debugging.
     * @type {string}
     * @memberof UserAuditLogQueryResponse
     */
    query: string;
    /**
     * ID in the MySQL database and BigQuery Audit Database for the user queried.
     * @type {number}
     * @memberof UserAuditLogQueryResponse
     */
    userDatabaseId: number;
}

/**
 * Check if a given object implements the UserAuditLogQueryResponse interface.
 */
export function instanceOfUserAuditLogQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "actions" in value;
    isInstance = isInstance && "logEntries" in value;
    isInstance = isInstance && "query" in value;
    isInstance = isInstance && "userDatabaseId" in value;

    return isInstance;
}

export function UserAuditLogQueryResponseFromJSON(json: any): UserAuditLogQueryResponse {
    return UserAuditLogQueryResponseFromJSONTyped(json, false);
}

export function UserAuditLogQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAuditLogQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actions': ((json['actions'] as Array<any>).map(AuditActionFromJSON)),
        'logEntries': ((json['logEntries'] as Array<any>).map(AuditLogEntryFromJSON)),
        'query': json['query'],
        'userDatabaseId': json['userDatabaseId'],
    };
}

export function UserAuditLogQueryResponseToJSON(value?: UserAuditLogQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'actions': ((value.actions as Array<any>).map(AuditActionToJSON)),
        'logEntries': ((value.logEntries as Array<any>).map(AuditLogEntryToJSON)),
        'query': value.query,
        'userDatabaseId': value.userDatabaseId,
    };
}

